module.exports = require("./kam");